import { handleActions } from 'redux-actions';
import { LandlordType, UserType } from 'ha/constants/UserType';
import { User } from '@ha/api/v2/types/User';
import { OCCUPATION } from '@ha/api/v2/types/Occupation';
import { Gender } from 'ha/types/Gender';
import { Language } from '@ha/intl';
import { Actions, LoadUserDonePayload } from '../constants';

export type State = Readonly<User>;

export const initialState: State = {
  avatarURL: '',
  birthDate: '',
  countryCode: '',
  phoneCountryCode: '',
  createdAt: '',
  description: '',
  firstName: '',
  lastName: '',
  email: '',
  isAdmin: false,
  isPartner: false,
  isAliased: false,
  gender: Gender.empty,
  hasFacebookProfile: false,
  hasPhone: false,
  phone: '',
  id: 0,
  uuid: '',
  isEmailVerified: false,
  isTrusted: false,
  lastActivityAt: '',
  location: '',
  nationality: '',
  responseRate: 0,
  responseTime: 0,
  smoker: '',
  spokenLanguages: [],
  study: '',
  type: UserType.UNVERIFIED,
  landlordType: LandlordType.OTHER,
  landlordTypeOther: '',
  uniId: 0,
  originUniId: 0,
  isVerifiedTenant: true,
  work: '',
  occupationDetail: '',
  occupation: OCCUPATION.unknown,
  notificationLang: 'en',
  lang: Language.en,
  enableSMSNotifications: false,
  enableBookingLink: false,
  logoURL: '',
  isManagedAccount: false,
  countryOfResidence: '',
  isBusinessAccount: false,
  roomsUnderManagement: '',
};

const entityReducer = handleActions(
  {
    [Actions.LOAD_USER_DONE]: (state, action: LoadUserDonePayload) => ({
      ...state,
      ...action.payload.user,
    }),
  },
  initialState,
);
export { entityReducer };
